"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var ConfirmModal = /** @class */ (function (_super) {
    __extends(ConfirmModal, _super);
    function ConfirmModal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConfirmModal.prototype.render = function () {
        return (React.createElement(reactstrap_1.Modal, { className: "my-2 notification-modal", isOpen: this.props.show, toggle: this.props.onHide },
            React.createElement(reactstrap_1.ModalHeader, { toggle: this.props.onHide },
                React.createElement("div", { className: "text-blue-2 font-weight-medium" }, this.props.title)),
            React.createElement(reactstrap_1.ModalBody, { className: "pt-0 fs-18" }, this.props.children),
            this.props.onConfirm
                ? React.createElement(reactstrap_1.ModalFooter, { className: "modal-footer d-flex flex-column-reverse flex-md-row justify-content-between" },
                    React.createElement("button", { type: "button", className: this.props.cancelButtonClassName ? this.props.cancelButtonClassName : "btn btn-white width-md-220 my-0", onClick: this.props.onHide }, this.props.cancelButtonText ? this.props.cancelButtonText : "Cancel"),
                    React.createElement("button", { type: "button", className: this.props.confirmButtonClassName ? this.props.confirmButtonClassName : "btn btn-primary btn-next width-md-220 mb-3 mt-0 my-md-0", onClick: this.props.onConfirm }, this.props.confirmButtonText ? this.props.confirmButtonText : "Ok"))
                : React.createElement(reactstrap_1.ModalFooter, { className: "modal-footer d-flex justify-content-center" },
                    React.createElement("button", { type: "button", className: this.props.confirmButtonClassName ? this.props.confirmButtonClassName : "btn btn-primary btn-next", onClick: this.props.onHide }, this.props.confirmButtonText ? this.props.confirmButtonText : "Ok"))));
    };
    return ConfirmModal;
}(React.Component));
exports.default = ConfirmModal;
//# sourceMappingURL=ConfirmModal.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/components/modals/ConfirmModal.js
// module id = 452
// module chunks = 0